import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import logger from './logger';

// Append-only audit trail for brewery accounts. Fire-and-forget: the trail
// must never break the action it records, so this swallows all errors.

export const logAudit = (
  breweryId: string,
  event: { action: string; target: string; targetId?: string; summary: string },
  user: { uid: string; email?: string | null }
): void => {
  try {
    addDoc(collection(db, 'breweries', breweryId, 'auditLog'), {
      action: event.action,
      target: event.target,
      targetId: event.targetId || '',
      summary: event.summary.slice(0, 500),
      userId: user.uid,
      userEmail: user.email || '',
      createdAt: serverTimestamp(),
    }).catch((err) => logger.error('Audit write failed:', err));
  } catch (err) {
    logger.error('Audit log error:', err);
  }
};
